import { render, staticRenderFns } from "./ProfitDetail.vue?vue&type=template&id=317f3e8c&"
import script from "./ProfitDetail.vue?vue&type=script&lang=js&"
export * from "./ProfitDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports